
        <!-- <field -->
        <fieldmagic-dialog
            label="Defects"
            icon="exclamation-circle"
            [instance]="this"
        >
            <ng-template fieldmagicDialogButtonsTmp>
            </ng-template>

            <ng-template fieldmagicDialogContentTmp>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <td width="5%">
                                <fieldmagic-text
                                    content="Severity"
                                    purpose="table-header"
                                >
                                </fieldmagic-text>
                            </td>
                            <td width="26%">
                                <fieldmagic-text
                                    content="Defect"
                                    purpose="table-header"
                                >
                                </fieldmagic-text>
                            </td>
                            <td width="30%">
                                <fieldmagic-text
                                    content="Comments"
                                    purpose="table-header"
                                >
                                </fieldmagic-text>
                            </td>
                            <td width="10%">
                                <fieldmagic-text
                                    content="Quote"
                                    purpose="table-header"
                                >
                                </fieldmagic-text>
                            </td>
                            <td width="16%">
                                <fieldmagic-text
                                    content="Date Resolved"
                                    purpose="table-header"
                                >
                                </fieldmagic-text>
                            </td>
                            <td width="16%">
                                <fieldmagic-text
                                    content="Date Reported"
                                    purpose="table-header"
                                >
                                </fieldmagic-text>
                            </td>
                        </tr>
                    </thead>

                    <tbody *ngIf="faults$ | async as faults">
                        <ng-container *ngIf="faults | blank">
                            <tr>
                                <td colspan="6" class="text-center">No defects found.</td>
                            </tr>
                        </ng-container>

                        <ng-container *ngFor="let fault of faults">
                            <tr>
                                <td
                                    [style.background]="fault.color"
                                    [style.color]="fault.color | bg_text_color"
                                >
                                    {{ fault.severity | translate }}
                                </td>
                                <td>{{ fault.fault | translate }}</td>
                                <td>{{ fault.comments | placeholdWithString }}</td>
                                <td>
                                    <ng-container *ngIf="fault.opportunity_id | filled">
                                        <a
                                            [routerLink]="['/opportunities', fault.opportunity_id]"
                                            target="_blank"
                                        >
                                            {{ '#%s' | sprintf: [fault.opportunity_text] }}
                                        </a>
                                    </ng-container>

                                    <ng-container *ngIf="fault.opportunity_id | blank">
                                        --
                                    </ng-container>
                                </td>
                                <td>
                                    <ng-container *ngIf="fault.date_resolved | filled">
                                        <div class="d-flex d-flex-gap">
                                            <span>
                                                {{ fault.date_resolved | format: 'll' }}
                                            </span>

                                            <fieldmagic-icon
                                                *ngIf="fault.resolution_notes | filled"
                                                [icon]="[{
                                                    icon: 'info-circle',
                                                    klass: 'text-info'
                                                }]"
                                                tooltip="{{ 'Notes: %s' | sprintf: [fault.resolution_notes] }}"
                                            >
                                            </fieldmagic-icon>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="fault.date_resolved | blank">
                                        --
                                    </ng-container>
                                </td>
                                <td>
                                    <div class="d-flex d-flex-gap">
                                        <span>{{ fault.date_reported | format: 'll' }}</span>

                                        <fieldmagic-icon
                                            [icon]="[{
                                                icon: 'info-circle',
                                                klass: 'text-info'
                                            }]"
                                            tooltip="{{ 'Reported By: %s' | sprintf: [fault.reported_by_text] }}"
                                        >
                                        </fieldmagic-icon>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </ng-template>
        </fieldmagic-dialog>
    